import { ConfirmationModal, Spinner } from '@components';
import BasicStep from '@features/group-management/components/v2/create-group/BasicStep';
import useEditGroupForm from '@features/group-management/hooks/useEditGroupForm';

import EditGroupHeader from './EditGroupHeader';

const EditGroup = () => {
  const {
    formData,
    onInputChange,
    memberList,
    isFeeCategoryEnabled,
    setIsFeeCategoryEnabled,
    feeCategories,
    setFeeCategories,
    branchDetails,
    customTermDueDateError,
    setCustomTermDueDateError,
    feeDetailsError,
    setFeeDetailsError,
    endDateError,
    setEndDateError,
    isSaveDisabled,
    isLoading,
    isPageLoading,
    onSaveEditGroup,
    hasGroupAttendanceEditAccess,
    handleAttendanceSwitchClick,
    groupId,
    isAttendanceBasedFee,
    hasChanges,
    showAutoDebitModal,
    setShowAutoDebitModal,
    onHandleAutoDebit,
    groupData
  } = useEditGroupForm();

  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-cofeeGreyBlue50">
      <EditGroupHeader
        groupId={groupId}
        onSave={onSaveEditGroup}
        isSaveDisabled={isSaveDisabled}
        isLoading={isLoading}
        hasChanges={hasChanges}
      />
      <div className="min-h-0 w-full flex-1 overflow-y-auto">
        <div className="mx-auto w-5/6 min-w-120 py-8">
          {isPageLoading ? (
            <div className="flex h-150 items-center justify-center">
              <Spinner />
            </div>
          ) : (
            <BasicStep
              formData={formData}
              onInputChange={onInputChange}
              memberList={memberList}
              isFeeCategoryEnabled={isFeeCategoryEnabled}
              setIsFeeCategoryEnabled={setIsFeeCategoryEnabled}
              feeCategories={feeCategories}
              setFeeCategories={setFeeCategories}
              branchDetails={branchDetails}
              customTermDueDateError={customTermDueDateError}
              setCustomTermDueDateError={setCustomTermDueDateError}
              feeDetailsError={feeDetailsError}
              setFeeDetailsError={setFeeDetailsError}
              endDateError={endDateError}
              setEndDateError={setEndDateError}
              hasGroupAttendanceEditAccess={hasGroupAttendanceEditAccess}
              handleAttendanceSwitchClick={handleAttendanceSwitchClick}
              isLoading={isLoading}
              isAttendanceBasedFee={isAttendanceBasedFee}
              isEditGroup
            />
          )}
        </div>
      </div>
      {showAutoDebitModal && (
        <ConfirmationModal
          isOpen={showAutoDebitModal}
          handleCancel={() => setShowAutoDebitModal(false)}
          handleConfirm={onHandleAutoDebit}
          title="Auto Debit"
          message={`${groupData?.auto_debit_enabled_default_member_count} autopay mandate for this group has a max limit below ₹${groupData?.group_member_mandate_max_amount}. This mandate will be cancelled if you proceed. Are you sure you want to continue?`}
          iconName="autopay"
          confirmButtonLabel="Proceed"
          primaryButtonVariant="primary"
          primaryButtonSize="medium"
          secondaryButtonVariant="secondary"
          secondaryButtonSize="medium"
          className="w-105 !pb-6"
        />
      )}
    </div>
  );
};

export default EditGroup;
